export const DEFAULT_PRONUNCIATION_LANGUAGE = 'en-US'

export const PRONUNCIATION_LANGUAGE_OPTIONS = [
  { value: 'en-US', label: 'English (United States)' },
  { value: 'en-GB', label: 'English (United Kingdom)' },
  { value: 'en-AU', label: 'English (Australia)' },
  { value: 'en-CA', label: 'English (Canada)' },
  { value: 'en-IN', label: 'English (India)' },
  { value: 'zh-CN', label: '中文（普通话）' },
  { value: 'zh-HK', label: '中文（粤语）' },
  { value: 'zh-TW', label: '中文（台湾）' },
  { value: 'fr-FR', label: 'Français (France)' },
  { value: 'fr-CA', label: 'Français (Canada)' },
  { value: 'de-DE', label: 'Deutsch' },
  { value: 'es-ES', label: 'Español (España)' },
  { value: 'es-MX', label: 'Español (México)' },
  { value: 'pt-BR', label: 'Português (Brasil)' },
  { value: 'pt-PT', label: 'Português (Portugal)' },
  { value: 'it-IT', label: 'Italiano' },
  { value: 'ja-JP', label: '日本語' },
  { value: 'ko-KR', label: '한국어' },
  { value: 'ar-EG', label: 'العربية (مصر)' },
  { value: 'ar-SA', label: 'العربية (السعودية)' },
  { value: 'ca-ES', label: 'Català' },
  { value: 'da-DK', label: 'Dansk' },
  { value: 'nl-NL', label: 'Nederlands' },
  { value: 'fi-FI', label: 'Suomi' },
  { value: 'hi-IN', label: 'हिन्दी' },
  { value: 'ms-MY', label: 'Bahasa Melayu' },
  { value: 'nb-NO', label: 'Norsk bokmål' },
  { value: 'pl-PL', label: 'Polski' },
  { value: 'ru-RU', label: 'Русский' },
  { value: 'sv-SE', label: 'Svenska' },
  { value: 'ta-IN', label: 'தமிழ்' },
  { value: 'th-TH', label: 'ไทย' },
  { value: 'vi-VN', label: 'Tiếng Việt' },
]

export const PRONUNCIATION_LANGUAGE_CODES = new Set(
  PRONUNCIATION_LANGUAGE_OPTIONS.map((option) => option.value)
)
